/**
 * Utility functions for className generation
 */

interface StepClassNameProps {
  isActive: boolean;
  isDisabled: boolean;
  isCompleted: boolean;
}

/**
 * Generate className string for step containers
 */
const getStepClassName = ({
  isActive,
  isDisabled,
  isCompleted,
}: StepClassNameProps): string => {
  const baseClass = 'step-container';
  const classes = [baseClass];

  if (isActive) {
    classes.push('active');
  }

  if (isDisabled) {
    classes.push('disabled');
  }

  if (isCompleted) {
    classes.push('completed');
  }

  return classes.join(' ');
};

export default getStepClassName;
